import { makeStyles } from 'lib/components'; // #genai

export default makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '16px',
    gap: '16px',
    boxShadow: theme.shadows[0],
    '@media (min-width: 1200px)': {
      boxShadow: theme.shadows[1],
      padding: '16px 24px',
    },
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    '@media (min-width: 1200px)': {
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'row',
      gap: '24px',
    },
  },
  title: {
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '36px',
  },
  companyInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '24px',
    padding: '16px',
    border: `1px solid ${theme.evPalette.charcoal[400]}`,
    borderRadius: '16px',
  },
  companyInfoText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    flex: 1,
  },
  companyName: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
  },
  companyAddress: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
  },
  editButton: {
    alignSelf: 'flex-start',
    width: '48px',
    height: '32px',
    border: `1px solid ${theme.evPalette.ocean[500]}`,
    borderRadius: '4px',
    backgroundColor: theme.evPalette.salt[100],
  },
  currentPeriodContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '16px',
  },
  viewConsumptionLink: {
    color: theme.evPalette.ocean[600],
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  currentPeriodText: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    '@media (min-width: 1200px)': {
      fontSize: '20px',
      lineHeight: '30px',
    },
  },
  subscriptionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    '@media (min-width: 1200px)': {
      alignItems: 'flex-start',
    },
  },
  subscriptionCardsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    flex: 1,
    '@media (min-width: 790px)': {
      gap: '16px',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
  },
  subscriptionsAndSummaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    gap: '24px',
    '@media (min-width: 1200px)': {
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
  },
  summaryPaper: {
    padding: '0px 16px',
    borderRadius: '4px',
    width: '100%',
    '@media (min-width: 1200px)': {
      width: '300px',
      minWidth: '300px',
    },
  },
  summaryTitle: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    marginBottom: '16px',
  },
  summaryContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  summaryRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
  },
  summaryDivider: {
    height: '1px',
    backgroundColor: theme.evPalette.charcoal[400],
    margin: '8px 0',
  },
  totalLabel: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
  },
  actionButtonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
    },
  },
  actionButton: {
    textTransform: 'none',
    flex: 1,
    '@media (min-width: 640px)': {
      flex: '0 1 auto',
      minWidth: '180px',
    },
  },
}));
